import { cssValue, spinAnimation } from '@lemonade-hq/cdk';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { DEFAULT_THEME } from '../../styles/theme.esm.js';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    box-sizing: border-box;\n    border-radius: 100%;\n    border-style: solid;\n    border-width: 2px;\n    display: inline-block;\n    width: ",
        ";\n    height: ",
        ";\n    animation: ",
        " 0.6s linear infinite;\n    border-color: ",
        ";\n    border-left-color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function spinnerStyles(param) {
    var _param_color = param.color, color = _param_color === void 0 ? DEFAULT_THEME.colors.metal : _param_color, _param_size = param.size, size = _param_size === void 0 ? "30px" : _param_size;
    var defaultBorderColorOpacityValue = 0.15;
    var defaultBorderLeftColorOpacityValue = 0.8;
    return css(_templateObject(), cssValue(size), cssValue(size), spinAnimation(), rgba(color, defaultBorderColorOpacityValue), rgba(color, defaultBorderLeftColorOpacityValue));
}
/* STYLED COMPONENT *******************************************************/ var Spinner = styled.div.attrs(function() {
    return {
        role: "progressbar",
        ariaBusy: "true"
    };
})(_templateObject1(), spinnerStyles);

export { Spinner, spinnerStyles };
